import { Injectable, signal, TemplateRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class PageActionsService {
  public readonly actions = signal<TemplateRef<unknown> | null>(null);

  public set(template: TemplateRef<unknown>): void {
    this.actions.set(template);
  }

  public clear(): void {
    this.actions.set(null);
  }
}
